import { Component, Input } from '@angular/core';
import { YoutubeElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-youtube-element-preview',
  templateUrl: './youtube-element-preview.component.html',
  styleUrls: ['./youtube-element-preview.component.scss'],
})
export class YoutubeElementPreviewComponent {
  @Input() public element: YoutubeElementPreviewFragment;
}
